<template>
    <form 
        class="user-registr-container" 
        @submit.prevent="submitForm" 
        novalidate
    >
      <b-container>
        <b-row>
          <b-col
              cols='12'
              class="registr-head"
          >
            {{'registrationUserDataHeader' | localize}}
          </b-col>
        </b-row>
        <div 
          class="registr-info" 
        >         
          <b-row class="px-3">
            <b-col 
                cols='12' md="9" xl='10'
                class="registr-inputs"
            >
              <div class="registr-input">
                <div class="description">
                  {{'registrationUserDataFIO' | localize}}: <span>*</span>
                </div>
                <div class="form">
                  <input 
                      type="text" 
                      class="form-control"
                      required
                      v-model="user_name"
                  >
                  <div 
                      class="form-description"
                      v-if="!$v.user_name.$dirty && !$v.user_name.required"
                  >
                    {{'registrationUserDataFIOError' | localize}}
                  </div>
                  <div 
                      class="form-description-error"
                      v-if="$v.user_name.$dirty && !$v.user_name.required"
                  >
                     {{'newAddressRequiredInput' | localize}}
                  </div>
                  <div 
                      class="form-description-error"
                      v-if="$v.user_name.$dirty && !$v.user_name.minLength"
                  >
                    {{'userProfileMinSymbolsSix' | localize}}
                  </div>
                </div>                           
              </div>
              <div class="registr-input">
                <div class="description">
                    {{'registrationUserDataMail' | localize}}: <span>*</span>
                </div>
                <div class="form">
                  <input 
                      type="email" 
                      class="form-control"
                      v-model="user_email"
                  >
                  <div 
                      class="form-description"
                      v-if="!$v.user_email.$dirty && !$v.user_email.required"
                  >
                      {{'registrationUserDataMailError' | localize}}
                  </div>
                  <div 
                      class="form-description-error"
                      v-if="$v.user_email.$dirty && !$v.user_email.required"
                  >
                      {{'newAddressRequiredInput' | localize}}
                  </div>
                  <div 
                      class="form-description-error"
                      v-if="$v.user_email.$dirty && !$v.user_email.email"
                  >
                      {{'registrationUserDataMailError' | localize}}
                  </div>
                </div>                           
              </div>
              <div class="registr-input">
                <div class="description">
                    {{'registrationUserDataTelephone' | localize}}: <span>*</span>
                </div>
                <div class="form">
                  <masked-input 
                      v-model="user_phone"  
                      mask="\+\38 (111) 111-11-11" 
                      class="form-control" 
                  />
                  <div 
                      class="form-description"
                      v-if="!$v.user_phone.$dirty && !$v.user_phone.required"
                  >
                      {{'registrationUserDataTelephoneError' | localize}}
                  </div>
                  <div 
                      class="form-description-error"
                      v-if="$v.user_phone.$dirty && !$v.user_phone.required"
                  >
                      {{'registrationUserDataTelephoneError2' | localize}}
                  </div>
                </div>                           
              </div>
              <div class="registr-input">
                <div class="description">
                    {{'registrationUserDataLogin' | localize}}: <span>*</span>
                </div>
                <div class="form">
                  <input 
                      type="text" 
                      class="form-control"
                      v-model="user_login"
                  >
                  <div 
                      class="form-description"
                      v-if=" !$v.user_login.required"
                  >
                      {{'registrationUserDataLoginError' | localize}}
                  </div>
                  <div 
                      class="form-description-error"
                      v-if="$v.user_login.$dirty && !$v.user_login.minLength"
                  >
                      {{'newAddressMinLength' | localize}}
                  </div>
                </div>                           
              </div>
                <div class="registr-input">
                    <div class="description">
                        {{'registrationUserDataPassword' | localize}}: <span>*</span>
                    </div>
                    <div class="form">
                        <input
                            :type="passwordFieldType"
                            class="form-control"
                            v-model="user_password"
                        >
                        <button @click="showPassword" :class="passwordButtonState"><span>&nbsp;</span></button>
                        <div
                            class="form-description"
                            v-if="!$v.user_password.$dirty && !$v.user_password.required"
                        >
                            {{'registrationUserDataPasswordError' | localize}}
                        </div>
                        <div 
                            class="form-description-error"
                            v-if="$v.user_password.$dirty && !$v.user_password.required"
                        >
                            {{'newAddressRequiredInput' | localize}}
                        </div>
                    <div 
                        class="form-description-error"
                        v-if="$v.user_password.$dirty && !$v.user_password.minLength"
                    >
                        {{'userProfileMinSymbolsSix' | localize}}
                    </div>
                    <div 
                        class="form-description-error"
                        v-if="$v.user_password.$dirty && !$v.user_password.maxLength"
                    >
                        {{'newAddressMaxLengthSixteen' | localize}}
                    </div>
                </div>                           
              </div>
              <div class="registr-input">
                <div class="description">
                    {{'registrationUserDataRepitPassword' | localize}}: <span>*</span>
                </div>
                <div class="form">
                  <input
                      :type="passwordFieldType"
                      class="form-control"
                      v-model="confirm_user_password"
                  >
                  <div 
                      class="form-description"
                      v-if="!$v.confirm_user_password.$dirty && !$v.confirm_user_password.required"
                  >
                      {{'registrationUserDataRepitPasswordDescription' | localize}}
                  </div>
                  <div 
                      class="form-description-error"
                      v-if="$v.confirm_user_password.$dirty && !$v.confirm_user_password.sameAs"
                  >
                      {{'registrationUserDataRepitPasswordError' | localize}}
                  </div>
                </div>                           
              </div>
            </b-col>
            <b-col
                cols='12' md='3' xl='2'
                class="registr-submit"
            >


              <vue-recaptcha 
                  class="captcha"
                  :sitekey="captcha_key" 
                  size="compact"  
                  @verify="onVerify"
                  @expired="onExpired"
                  :loadRecaptchaScript="true"
              ></vue-recaptcha>

                <b-form-checkbox
                class="mb-3"
                id="checkbox-1"
                v-model="status"
                value="true"
                unchecked-value="false"
                >
                    {{'registrationAgreement1' | localize}} 
                    <a :href="ugodaUrl"  target="_blank"> {{'registrationAgreement2' | localize}} </a>
                </b-form-checkbox>
              <b-button variant="outline-dark" type="submit" :disabled="isDisabledSubmit">{{'registrationButton' | localize}}</b-button>
            </b-col>
          </b-row>
        </div>
      </b-container>        
    </form>
</template>
<script>
import config from '@/config'
import { mapGetters } from 'vuex'
import MaskedInput from 'vue-masked-input'
import VueRecaptcha from 'vue-recaptcha';
import { validationMixin } from 'vuelidate'
import { required, minLength, maxLength, email, helpers, sameAs } from 'vuelidate/lib/validators'
import base64url from "base64url";
const alpha = helpers.regex('alpha', /^[a-zA-Zа-яА-яёЁїЇЄєґҐіІ`'’ -]+$/)
export default {
    mixins: [validationMixin],
    data: () => ({
        passwordFieldType: "password",
        passwordButtonState: 'hide_password_button',
        captcha_key: config.CAPTCHA_KEY,
        ugodaUrl: config.API_URL + '/api/rest/receipt/get_ugoda',
        captcha_verify: null,
        userINN: '',
        access_code: 123,
        user_name: '',
        user_email: '',
        user_phone: '',
        user_login: '',
        user_password: '',
        confirm_user_password: '',
        text_message: '',
        status: false
    }),
    validations: {
        user_name: {required, minLength: minLength(6), alpha},
        user_email: { required, email },
        user_phone: { required,},
        user_login: { minLength: minLength(3) },
        user_password: {required, minLength: minLength(6), maxLength: maxLength(16) },
        confirm_user_password: {sameAs: sameAs('user_password')},
    },
    computed: {
      ...mapGetters(['registrationResponse', 'locale']),
      isDisabledSubmit: function (){
        return ! (this.captcha_verify && this.status)
      }
    },
    methods: {
        onSubmit: function () {
        this.$refs.invisibleRecaptcha.execute()
        },
        onVerify: function (response) {
            this.captcha_verify = response
        },
        onExpired: function () {
          this.captcha_verify = null
        },
        resetRecaptcha () {
            this.$refs.recaptcha.reset()
        },
        submitForm(){
            if(!this.captcha_verify){
                console.log('captcha error')
            } else {
                if(this.status === 'true'){
                    this.userData()
                }
                
            }
        },
        showPassword(){
          if(this.passwordFieldType === 'password') {
            this.passwordFieldType = 'text'
            this.passwordButtonState = 'show_password_button'
          } else {
            this.passwordFieldType = 'password'
            this.passwordButtonState = 'hide_password_button'
          }
        },
        
        async userData(){
          if(this.$v.$invalid){
              this.$v.$touch()
          } else {
            if(this.user_login === ''){this.user_login = this.user_email }
            this.user_phone = this.user_phone.replace(/\D/g,'');

            const user = {
                login: this.user_login,
                password: this.user_password,
                fio: this.user_name,
                mail: this.user_email,
                tel: this.user_phone,
                secret_key: '',
                recaptchaTooken: this.captcha_verify
            }
            await this.$store.dispatch('registrationUser', user)
            
            if(this.registrationResponse.cod === '0'){
                this.$messageLocalized("registrationSuccessful").then(()=>{
                  const loginData = {
                    login: user.login,
                    password: user.password
                  }
                  localStorage.setItem('weltumPass', base64url(user.password) )
                  this.$store.dispatch('login', loginData)
                      .then(() => {
                        let data = loginData
                        data.password = base64url(loginData.password)
                        localStorage.setItem('weltInfo',JSON.stringify(data))
                        this.$router.push(`${config.ROUTE_PREFIX}/`)
                      })
                })

            } else if(this.registrationResponse.cod === '1'){
              this.$messageLocalized("accountAlreadyExists")
            }
          }
        },
    },
    components: { MaskedInput, VueRecaptcha }
}
</script>